export const SAVE_DEAL_TEMPLATE = 'SAVE_DEAL_TEMPLATE';
export const SAVE_DEAL_TEMPLATE_REQUEST = 'SAVE_DEAL_TEMPLATE_REQUEST';
export const SAVE_DEAL_TEMPLATE_SUCCESS = 'SAVE_DEAL_TEMPLATE_SUCCESS';
export const SAVE_DEAL_TEMPLATE_FAILURE = 'SAVE_DEAL_TEMPLATE_FAILURE';
export const GET_DEAL_TEMPLATES = 'GET_DEAL_TEMPLATES';
export const GET_DEAL_TEMPLATES_REQUEST = 'GET_DEAL_TEMPLATES_REQUEST';
export const GET_DEAL_TEMPLATES_SUCCESS = 'GET_DEAL_TEMPLATES_SUCCESS';
export const GET_DEAL_TEMPLATES_FAILURE = 'GET_DEAL_TEMPLATES_FAILURE';
export const GET_MANUAL_DEAL_TEMPLATES = 'GET_MANUAL_DEAL_TEMPLATES';
export const GET_MANUAL_DEAL_TEMPLATES_REQUEST = 'GET_MANUAL_DEAL_TEMPLATES_REQUEST';
export const GET_MANUAL_DEAL_TEMPLATES_SUCCESS = 'GET_MANUAL_DEAL_TEMPLATES_SUCCESS';
export const GET_MANUAL_DEAL_TEMPLATES_FAILURE = 'GET_MANUAL_DEAL_TEMPLATES_FAILURE';
export const UPDATE_DEAL_TEMPLATE = 'UPDATE_DEAL_TEMPLATE';
export const UPDATE_DEAL_TEMPLATE_REQUEST = 'UPDATE_DEAL_TEMPLATE_REQUEST';
export const UPDATE_DEAL_TEMPLATE_SUCCESS = 'UPDATE_DEAL_TEMPLATE_SUCCESS';
export const UPDATE_DEAL_TEMPLATE_FAILURE = 'UPDATE_DEAL_TEMPLATE_FAILURE';
export const DROP_UPDATE_DEAL_TEMPLATE = 'DROP_UPDATE_DEAL_TEMPLATE';
export const DELETE_DEAL_TEMPLATE = 'DELETE_DEAL_TEMPLATE';
export const DELETE_DEAL_TEMPLATE_REQUEST = 'DELETE_DEAL_TEMPLATE_REQUEST';
export const DELETE_DEAL_TEMPLATE_SUCCESS = 'DELETE_DEAL_TEMPLATE_SUCCESS';
export const DELETE_DEAL_TEMPLATE_FAILURE = 'DELETE_DEAL_TEMPLATE_FAILURE';
export const DROP_DELETE_DEAL_TEMPLATE = 'DROP_DELETE_DEAL_TEMPLATE';
export const TOGGLE_TEMPLATE_LIST_DRAWER = 'TOGGLE_TEMPLATE_LIST_DRAWER';
export const TOGGLE_SAVE_PAYMENT_TERMS = 'TOGGLE_SAVE_PAYMENT_TERMS';
export const TRIGGER_TEMPLATE_BUILDER_MODE = 'TRIGGER_TEMPLATE_BUILDER_MODE';
export const MANUALLY_APPLY_DEAL_TEMPLATE = 'MANUALLY_APPLY_DEAL_TEMPLATE';
export const MANUALLY_APPLY_DEAL_TEMPLATE_REQUEST = 'MANUALLY_APPLY_DEAL_TEMPLATE_REQUEST';
export const APPLY_ORIGINAL_TEMPLATE_PRODUCTS = 'APPLY_ORIGINAL_TEMPLATE_PRODUCTS';
export const APPLY_TEMPLATE_PRODUCTS = 'APPLY_TEMPLATE_PRODUCTS';
export const REVERT_MANUALLY_APPLIED_TEMPLATE = 'REVERT_MANUALLY_APPLIED_TEMPLATE';
export const INIT_TEMPLATE_FROM_DEAL_REQUEST = 'INIT_TEMPLATE_FROM_DEAL_REQUEST';
export const INIT_TEMPLATE_FROM_DEAL_SUCCESS = 'INIT_TEMPLATE_FROM_DEAL_SUCCESS';
export const INIT_TEMPLATE_FROM_DEAL_FAILURE = 'INIT_TEMPLATE_FROM_DEAL_FAILURE';
